// Thin fetch wrapper for /api/admin/* — every call is same-origin, cookie
// session auth (see worker/admin-routes.ts), so this only needs to set
// headers and turn a non-2xx response into a thrown Error with the server's
// message.
export async function api<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) },
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new Error((data && (data.error as string)) || `${res.status} ${res.statusText}`);
  }
  return data as T;
}

export function apiGet<T = unknown>(path: string): Promise<T> {
  return api<T>(path);
}

export function apiPost<T = unknown>(path: string, body?: unknown): Promise<T> {
  return api<T>(path, { method: "POST", body: body !== undefined ? JSON.stringify(body) : undefined });
}

export function apiPut<T = unknown>(path: string, body?: unknown): Promise<T> {
  return api<T>(path, { method: "PUT", body: body !== undefined ? JSON.stringify(body) : undefined });
}

export function apiDelete<T = unknown>(path: string): Promise<T> {
  return api<T>(path, { method: "DELETE" });
}
